<script setup lang="ts">
import { onMounted, ref } from 'vue'

import { api, messageFrom } from '../api'

interface Summary {
  costs: { day: number; week: number; month: number }
  averageCostRub: number
  byModel: Array<{ code: string; title: string; images: number; costRub: number }>
  conversion: { uploaded: number; generated: number; percent: number }
}

const summary = ref<Summary | null>(null)
const error = ref('')
const loading = ref(true)

async function load(): Promise<void> {
  loading.value = true
  error.value = ''
  try { summary.value = await api<Summary>('/api/admin/summary') }
  catch (reason) { error.value = messageFrom(reason) }
  finally { loading.value = false }
}

function rub(value: number): string { return `${value.toFixed(2)} ₽` }

onMounted(() => void load())
</script>

<template>
  <main class="page">
    <div class="page-title">
      <div><p class="eyebrow">Экономика MVP</p><h2>Сводка</h2></div>
      <button class="button button--quiet" type="button" @click="load">Обновить</button>
    </div>
    <p v-if="error" class="error">{{ error }}</p>
    <p v-if="loading" class="muted">Считаю…</p>
    <template v-else-if="summary">
      <section class="metric-grid">
        <article class="metric"><span>Сегодня</span><strong>{{ rub(summary.costs.day) }}</strong></article>
        <article class="metric"><span>7 дней</span><strong>{{ rub(summary.costs.week) }}</strong></article>
        <article class="metric"><span>30 дней</span><strong>{{ rub(summary.costs.month) }}</strong></article>
        <article class="metric"><span>Средняя картинка</span><strong>{{ rub(summary.averageCostRub) }}</strong></article>
      </section>
      <section class="panel conversion">
        <div><p class="eyebrow">Воронка</p><h3>Фото → генерация</h3></div>
        <strong>{{ summary.conversion.percent.toFixed(1) }}%</strong>
        <p>{{ summary.conversion.generated }} из {{ summary.conversion.uploaded }} загрузивших фото сделали картинку.</p>
      </section>
      <section class="panel">
        <h3>Расход по моделям за 30 дней</h3>
        <div class="table-wrap">
          <table>
            <thead><tr><th>Модель</th><th>Картинок</th><th>Расход</th><th>Средняя</th></tr></thead>
            <tbody>
              <tr v-for="model in summary.byModel" :key="model.code">
                <td>{{ model.title }}</td><td>{{ model.images }}</td><td>{{ rub(model.costRub) }}</td>
                <td>{{ model.images ? rub(model.costRub / model.images) : '—' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </template>
  </main>
</template>
